module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-dark-screens-4-1.5d072816.png";